import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getDifyAssistants } from "services/difyService";
import AssistantTile from "./assistantTile";

const Assistants = () => {
  const [assistants, setAssistants] = useState([]);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    getAssistants();
  }, []);

  const getAssistants = async () => {
    var s = await getDifyAssistants();
    var d = s.installed_apps;
    setAssistants(d);
    setTags(
      d
        .map((x) => x.app.mode)
        .filter((x) => x != "" && x != null)
        .filter(onlyUnique)
    );
  };

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  const toggleTag = (tag) => {
    if (tags.indexOf(tag) == -1) {
      setTags([...tags, tag]);
    } else {
      setTags([...tags.filter((x) => x != tag)]);
    }
  };

  const tagInactive = (tag) => {
    return tags.indexOf(tag) == -1;
  };

  return (
    <div className="p-4 bg-[#EDEDED] h-full">
      <div className="flex gap-2 pb-4 items-center">
        Filters:
        {assistants
          .map((x) => x.app.mode)
          .filter(onlyUnique)
          .map((x) => {
            return (
              <div
                key={x}
                onClick={(e) => toggleTag(x)}
                className={`rounded-xl py-2 px-4 cursor-pointer bg-[#696375] text-white hover:bg-[#787383] ${
                  tagInactive(x) ? "bg-gray-200" : ""
                }`}
              >
                {x}
              </div>
            );
          })}
      </div>
      <div className="grid gap-10 grid-cols-4">
        {assistants
          .filter((x) => tags.indexOf(x.app.mode) > -1)
          .filter((x) => x.app?.name != "" && x.app?.name != null)
          ?.sort((a, b) => a.app.mode - b.app.mode)
          .map((assistant) => {
            return <AssistantTile key={assistant.id} app={assistant.app} />;
          })}
      </div>
    </div>
  );
};
export default Assistants;
